import type { Bank } from "@/apis/gql/types";
import { FinApiWebForm } from "@/components/shared/finapi/fin-api-web-form";
import { ErrorMessage } from "@/components/ui/error";
import { useParams } from "@tanstack/react-router";

type Props = {
  webformId: string | null;
};

export const ConnectionStepFinapi = ({ webformId }: Props) => {
  const { company: companySlug } = useParams({ strict: false });

  if (!webformId) {
    return (
      <div className="flex-1 flex justify-center items-center h-full">
        <ErrorMessage />
      </div>
    );
  }

  const baseRedirectUrl = `${window.location.origin}/${companySlug}/unternehmen/einstellungen/bank`;

  const successRedirectParams = new URLSearchParams();

  const successState = JSON.stringify({
    open: false,
    step: 0,
    success: true,
    error: false,
    abort: false,
  });
  successRedirectParams.set(
    "bank-connection-dialog-state",
    encodeURIComponent(successState),
  );

  const successRedirectUrl = `${baseRedirectUrl}?${successRedirectParams.toString()}`;

  const errorRedirectParams = new URLSearchParams();
  const errorState = JSON.stringify({
    open: false,
    step: 0,
    success: false,
    error: true,
    abort: false,
  });
  errorRedirectParams.set(
    "bank-connection-dialog-state",
    encodeURIComponent(errorState),
  );

  const errorRedirectUrl = `${baseRedirectUrl}?${errorRedirectParams.toString()}`;

  const abortRedirectParams = new URLSearchParams();
  const abortState = JSON.stringify({
    open: false,
    step: 0,
    success: false,
    error: false,
    abort: true,
  });
  abortRedirectParams.set(
    "bank-connection-dialog-state",
    encodeURIComponent(abortState),
  );

  const abortRedirectUrl = `${baseRedirectUrl}?${abortRedirectParams}`;

  return (
    <div>
      <FinApiWebForm
        id={webformId}
        targetUrl="https://webform-live.finapi.io"
        redirectUrl={successRedirectUrl}
        errorRedirectUrl={errorRedirectUrl}
        abortRedirectUrl={abortRedirectUrl}
      />
    </div>
  );
};
